<template>
  <v-dialog v-model="dialog" width="auto" open-delay="3000">
    <v-card>
      <v-card-text>
        <v-table>
          <tbody class="text-left">
            <!-- Environment -->
            <tr>
              <th class="user-select-auto">{{ $t('AppEnvironment') }}</th>
              <td>{{ $config.public.APP_ENVIRONMENT || $t('Undefined') }}</td>
            </tr>
            <!-- Version -->
            <tr>
              <th class="user-select-auto">
                {{ $t('AppVersion') }}
                <DebugHintIcon :to-json="versionInfo.items"></DebugHintIcon>
              </th>
              <td>
                <div class="version-row">
                  <div class="version-list">
                    <!-- Frontend Version -->
                    <div v-for="versionItem in versionInfo.items.value" :key="versionItem.label" class="version-entry">
                      <span class="version-label">{{ versionItem.label }}:</span>
                      <span>
                        {{ versionItem.version || $t('Undefined') }}
                        <template v-if="versionItem.commit">
                          (
                          <!-- Link -->
                          <a
                            v-if="versionItem.commit.url"
                            :href="versionItem.commit.url"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <code :title="versionItem.commit.long">
                              {{ versionItem.commit.short }}
                            </code>
                            <v-icon color="primary">mdi-open-in-new</v-icon>
                          </a>

                          <!-- Text -->
                          <code v-else :title="versionItem.commit.long">
                            {{ versionItem.commit.short }}
                          </code>
                          )
                        </template>
                      </span>
                    </div>
                  </div>
                  <!-- Copy -->
                  <ContentCopy :content="versionInfo.copyContent.value" />
                </div>
              </td>
            </tr>

            <!-- Development -->
            <tr>
              <th class="user-select-auto">{{ $t('AppDevelopment') }}</th>
              <td>
                <a href="https://gridside.de/" target="_blank">
                  GRIDSIDE ENERGY CONSULT GMBH
                  <v-icon color="primary">mdi-open-in-new</v-icon>
                </a>
                <br />
                <a href="https://helmundwalter.de/" target="_blank">
                  Helm & Walter IT-Solutions GmbH
                  <v-icon color="primary">mdi-open-in-new</v-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-spacer />
        <v-btn variant="text" @click="dialog = false">{{ $t('ButtonClose') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, useModel, watch } from 'vue'
import ContentCopy from '~/components/Common/ContentCopy.vue'
import { injectHandleFetchError } from '~/plugins/vue-plugins/fetch-error-handler'
import { useAppVersionInfo } from '~/composables/useAppVersionInfo'
import DebugHintIcon from '~/components/Common/DebugHintIcon.vue'

export default defineComponent({
  name: 'AppAboutDialog',
  components: {
    DebugHintIcon,
    ContentCopy,
  },
  props: {
    modelValue: {
      required: true,
      type: Boolean,
    },
  },
  emits: ['update:modelValue'],
  setup(props) {
    const dialog = useModel(props, 'modelValue')
    const handleFetchError = injectHandleFetchError()
    const versionInfo = useAppVersionInfo({
      onError: handleFetchError,
    })

    watch(dialog, (newValue) => {
      if (!newValue) {
        return
      }
      versionInfo.ensureVersionsLoaded()
    })

    return {
      versionInfo,
      dialog,
    }
  },
})
</script>

<style scoped lang="scss">
.user-select-auto {
  user-select: auto;
}

.version-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.version-list {
  display: grid;
  gap: 4px;
}

.version-entry {
  display: flex;
  gap: 8px;
}

.version-label {
  font-weight: 600;
}
</style>
